import PropTypes from "prop-types";

Challenge.propTypes = {
  challenge: PropTypes.object.isRequired,
  onExit: PropTypes.func.isRequired
};

import Question from "./Question.jsx";
import {formatTime} from "./ChallengeUtil.jsx";
import {useEffect, useState} from "react";
import {ANSWER_LAG_TIME} from "./QuestionUtil.jsx";
import ChallengeResults from "./ChallengeResults.jsx";

const STATES = {
  IN_PROGRESS: "in-progress",
  FINISHED: "finished"
}

let interval = null;

export default function Challenge({challenge, onExit}) {

  // setup initial state
  const [state, setState] = useState(STATES.IN_PROGRESS);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [remainingTime, setRemainingTime] = useState(challenge.time);
  const [results, setResults] = useState({
    correct: 0,
    incorrect: 0,
    answers: []
  });

  // start timer
  useEffect(() => {
    if (state === STATES.IN_PROGRESS) {
      interval = setInterval(() => {
        setRemainingTime((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(interval); // Cleanup on unmount or re-render
  }, [challenge, state]);

  // stop timer when challenge is finished or time is up
  useEffect(() => {
    if (state === STATES.FINISHED || remainingTime <= 0) {
      endChallenge();
    }
  }, [state, remainingTime]);

  function handleAnswer(answer) {
    setResults((prev) => ({
      ...prev,
      correct: answer.correct ? prev.correct + 1 : prev.correct,
      incorrect: answer.correct ? prev.incorrect : prev.incorrect + 1,
      answers: [...prev.answers, {
        question: challenge.questions[currentQuestion].question,
        correct: answer.correct,
        selected: answer.text
      }]
    }));

    const timeoutInterval = answer.correct ? ANSWER_LAG_TIME.CORRECT : ANSWER_LAG_TIME.INCORRECT;
    setTimeout(() => {
      if (currentQuestion < challenge.questions.length - 1) {
        setCurrentQuestion((prev) => prev + 1)
      } else {
        endChallenge();
      }
    }, timeoutInterval);
  }

  function startChallenge() {
    setState(STATES.IN_PROGRESS);
    setResults({
      correct: 0,
      incorrect: 0,
      answers: []
    });
    setCurrentQuestion(0);
    setRemainingTime(challenge.time);
  }

  function endChallenge() {
    clearInterval(interval);
    interval = null;
    setState(STATES.FINISHED);
  }

  return (
    <div className="challenge-main">
      <h1 className="challenge-title">{challenge.title}</h1>
      <div className="challenge-header">
        <div className="challenge-stat correct">Correct: {results.correct}</div>
        <div className="challenge-stat incorrect">Incorrect: {results.incorrect}</div>
        <div className="challenge-stat">
          Unanswered: {challenge.questions.length - results.correct - results.incorrect}
        </div>
        <div className="challenge-stat">Time: {formatTime(remainingTime)}</div>
      </div>
      {state === STATES.IN_PROGRESS && <>
        <Question question={challenge.questions[currentQuestion]} onAnswer={handleAnswer}/>
        <button className="challenge-start-button" onClick={endChallenge}>End Challenge</button>
      </>}
      {state === STATES.FINISHED && <>
        <ChallengeResults challenge={challenge} results={results}/>
        <div className="challenge-results-buttons">
          <button className="challenge-start-button" onClick={startChallenge}>Try again</button>
          <button className="challenge-return-button" onClick={onExit}>Return</button>
        </div>
      </>}
    </div>
  )
}